import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight, Star, TrendingDown } from 'lucide-react';
export function BeforeAfterSection() {
  return <Section background="cream" id="resultados" data-id="element-6">
      <div className="text-center mb-12" data-id="element-7">
        <div className="inline-flex items-center gap-2 bg-[#D4AF37]/20 text-[#8B6914] px-4 py-2 rounded-full text-sm font-bold mb-4 uppercase tracking-wide" data-id="element-8">
          <Star className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" data-id="element-9" />
          Resultados Verificados
        </div>
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-10">
          Transformaciones Reales en{' '}
          <span className="text-[#D4AF37]" data-id="element-11">21 Días o Menos</span>
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-12">
          Sin cirugías. Sin pastillas. Sin dietas extremas. Solo el poder del
          veneno de abeja trabajando mientras duermes.
        </p>
      </div>

      {/* Before/After Cards */}
      <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-13">
        {/* Woman transformation */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl overflow-hidden shadow-lg border border-[#D4AF37]/20" data-id="element-14">
          <div className="relative" data-id="element-15">
            <img src="https://cdn.magicpatterns.com/uploads/oZwwruY4XkC8SnqgKGUnBE/imgi_8_1768347383-ChatGPT_Image_Jan_142C_20262C_12_36_02_AM.png" alt="Transformación femenina con StingFit - Antes y Después" className="w-full object-cover" data-id="element-16" />
          </div>
          <div className="p-6" data-id="element-17">
            <div className="flex items-center gap-3 mb-3" data-id="element-18">
              <div className="flex" data-id="element-19">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" data-id="element-20" />)}
              </div>
              <span className="text-sm font-bold text-gray-700" data-id="element-21">
                Laura M., 38 años
              </span>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-4" data-id="element-22">
              "No podía creer lo que veía en el espejo. En solo 3 semanas perdí
              7 kg y 9 cm de cintura. Mis amigas me preguntan qué hice."
            </p>
            <div className="flex gap-4" data-id="element-23">
              <div className="flex items-center gap-1.5 bg-green-50 px-3 py-1.5 rounded-full" data-id="element-24">
                <TrendingDown className="w-3.5 h-3.5 text-green-600" data-id="element-25" />
                <span className="text-xs font-bold text-green-700" data-id="element-26">
                  -7 kg en 21 días
                </span>
              </div>
              <div className="flex items-center gap-1.5 bg-green-50 px-3 py-1.5 rounded-full" data-id="element-27">
                <TrendingDown className="w-3.5 h-3.5 text-green-600" data-id="element-28" />
                <span className="text-xs font-bold text-green-700" data-id="element-29">
                  -9 cm cintura
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Man transformation */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="bg-white rounded-3xl overflow-hidden shadow-lg border border-[#D4AF37]/20" data-id="element-30">
          <div className="relative" data-id="element-31">
            <img src="https://cdn.magicpatterns.com/uploads/iMNe9usqZu64Fnv9oH9j9Q/imgi_18_1768348001-ChatGPT_Image_Jan_142C_20262C_12_46_19_AM.png" alt="Transformación masculina con StingFit - Antes y Después" className="w-full object-cover" data-id="element-32" />
          </div>
          <div className="p-6" data-id="element-33">
            <div className="flex items-center gap-3 mb-3" data-id="element-34">
              <div className="flex" data-id="element-35">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" data-id="element-36" />)}
              </div>
              <span className="text-sm font-bold text-gray-700" data-id="element-37">
                Carlos R., 45 años
              </span>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-4" data-id="element-38">
              "Llevaba años intentando bajar la barriga sin éxito. StingFit fue
              la solución que no sabía que existía. Resultados increíbles."
            </p>
            <div className="flex gap-4" data-id="element-39">
              <div className="flex items-center gap-1.5 bg-green-50 px-3 py-1.5 rounded-full" data-id="element-40">
                <TrendingDown className="w-3.5 h-3.5 text-green-600" data-id="element-41" />
                <span className="text-xs font-bold text-green-700" data-id="element-42">
                  -12 kg en 30 días
                </span>
              </div>
              <div className="flex items-center gap-1.5 bg-green-50 px-3 py-1.5 rounded-full" data-id="element-43">
                <TrendingDown className="w-3.5 h-3.5 text-green-600" data-id="element-44" />
                <span className="text-xs font-bold text-green-700" data-id="element-45">
                  -14 cm cintura
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Stats bar */}
      <div className="bg-[#2D5016] rounded-2xl p-6 md:p-8 grid grid-cols-2 md:grid-cols-4 gap-6 text-center mb-10" data-id="element-46">
        <div data-id="element-47">
          <p className="text-3xl font-black text-[#D4AF37]" data-id="element-48">10.000+</p>
          <p className="text-sm text-green-100 mt-1" data-id="element-49">Clientes satisfechos</p>
        </div>
        <div data-id="element-50">
          <p className="text-3xl font-black text-[#D4AF37]" data-id="element-51">94%</p>
          <p className="text-sm text-green-100 mt-1" data-id="element-52">
            Ven resultados en 14 días
          </p>
        </div>
        <div data-id="element-53">
          <p className="text-3xl font-black text-[#D4AF37]" data-id="element-54">-8 kg</p>
          <p className="text-sm text-green-100 mt-1" data-id="element-55">
            Pérdida media en 21 días
          </p>
        </div>
        <div data-id="element-56">
          <p className="text-3xl font-black text-[#D4AF37]" data-id="element-57">4.9★</p>
          <p className="text-sm text-green-100 mt-1" data-id="element-58">Valoración media</p>
        </div>
      </div>

      <div className="text-center" data-id="element-59">
        <Button size="xl" className="group shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1" onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-60">
          <span className="flex items-center font-bold tracking-wide" data-id="element-61">
            QUIERO MI TRANSFORMACIÓN
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-62" />
          </span>
        </Button>
        <p className="text-xs text-gray-500 mt-3" data-id="element-63">
          Garantía de 90 días • Sin riesgo
        </p>
      </div>
    </Section>;
}